// extracted by mini-css-extract-plugin
module.exports = {"removeFlow":"removeFlow--xq3RW","addedFlowItem":"addedFlowItem--FRE5Q"};